// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"340d3672","703":"91447917"}[chunkId] + ".chunk.js";
};